import React, { ReactNode, useState } from 'react';
import './AccountMenu.scss';
import { FaEllipsisV } from 'react-icons/fa';
import './GenericSettingsMenu.scss';
import Button from './Button';
import DeleteButton from './DeleteButton';
type GenericSettingsAction = {
  text: string;
  children?: ReactNode;
  action: () => void;
  deleteMessage?: string;
  isLoading?: boolean;
};
type GenericSettingsMenuProps = {
  title?: string | undefined;
  actions: GenericSettingsAction[];
  secondaryActions?: GenericSettingsAction[];
  responsiveActions?: GenericSettingsAction[];
};
const GenericSettingsMenu: React.FC<GenericSettingsMenuProps> = ({
  title,
  actions,
  secondaryActions,
  responsiveActions
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen((p) => !p);
  };

  const doAction = (button: GenericSettingsAction) => {
    setIsOpen(false);
    button.action();
  };

  const renderAction = (p: GenericSettingsAction, className?: string) => {
    if (p.deleteMessage) {
      return (
        <DeleteButton
          message={p.deleteMessage}
          isLoading={p.isLoading ?? false}
          key={p.text}
          className={`card-menu-item ${className ? `card-menu-item__${className}` : ''}`}
          onClick={() => doAction(p)}
        >
          {p.children ?? p.text}
        </DeleteButton>
      );
    }
    return (
      <Button
        isLoading={p.isLoading ?? false}
        key={p.text}
        className={`card-menu-item ${className ? `card-menu-item__${className}` : ''}`}
        onClick={() => doAction(p)}
      >
        {p.children ?? p.text}
      </Button>
    );
  };

  return (
    <div className="menu-container">
      <Button isIcon={true} onClick={toggleMenu}>
        <FaEllipsisV className="icon" />
      </Button>
      {isOpen && (
        <div className="card-menu">
          {title && (
            <div className="card-menu__title">
              <h2>{title}</h2>
              <hr />
            </div>
          )}
          {responsiveActions && (
            <>
              {responsiveActions.map((p) => renderAction(p, 'responsive'))}
              <hr className="card-menu-break__responsive" />
            </>
          )}
          {actions.map((p) => renderAction(p))}
          {secondaryActions && (
            <>
              <hr />
              {secondaryActions.map((p) => renderAction(p))}
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default GenericSettingsMenu;
